module.exports = __webpack_public_path__ + "static/media/horizontal-logo.5a6fead2.png";